var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');

// Job Area
module.exports = React.createClass({
	
	getInitialState : function(){
		return {
			selected : this.props.gender
		}
	},
	
	selectGender : function(e){
		this.setState({
			selected : $(e.currentTarget).data('gender')
		});
	},
	
	// Render
  	render: function(){
  		
  		var femaleClasses = "gender-checker female";
  		var maleClasses = "gender-checker male";
  		
  		if(this.state.selected === 'female'){
	  		femaleClasses += ' selected';
  		}
  		
  		if(this.state.selected === 'male'){
	  		maleClasses += ' selected';
  		}
  		
   		return (<div className="gender-selctor">
   			
   			<input type="hidden" name="gender" value={this.state.selected} />
   			
   			<div onClick={this.selectGender} className={femaleClasses} data-gender="female">
   				<span className="fa fa-female icon"></span>
   				<span className="text">Female</span>
   			</div>
		   	
		   	<div onClick={this.selectGender} className={maleClasses} data-gender="male">
		   		<span className="fa fa-male icon"></span>
		   		<span className="text">Male</span>
		   	</div>
		   	
		   	<div className="clear"></div>
	  	</div>);
	}
});
